/**
 * Calculate the offset for an offset-limit based query made for a virtualized data view (e.g. list, table, grid, etc.). Buffers the top and bottom of the window roughly evenly.
 *
 * @param {Number} rowStartIndex Index of the first visible row in the virtualized window
 * @param {Number} rowStopIndex Index of the last visible row in the virtualized window
 * @param {Number} queryRowCount Row count of data being queried. Used to determine the maximum row index.
 * @param {Number} currentLimit Current limit (i.e. max rows returned) for data being queried
 */
export function calculateOffset(rowStartIndex, rowStopIndex, queryRowCount, currentLimit) {
  const windowSize = rowStopIndex - rowStartIndex + 1
  const bufferRowCount = currentLimit - windowSize
  const calculatedOffset = Math.floor(rowStartIndex - bufferRowCount * 0.5)
  const newOffset =
    calculatedOffset + currentLimit > queryRowCount
      ? queryRowCount - currentLimit
      : calculatedOffset < 0
        ? 0
        : calculatedOffset
  return newOffset
}

/**
 * Make an array for dataset rows that is padded in the front and back so that the array length is accurate for the read-only grid view.
 *
 * NOTE: Padding an array like this doesn't (or at least we don't expect it to) allocate memory but only sets the array length. JavaScript is great like that. :)
 *
 * @param {Array} rows
 * @param {Number} offset
 */
export function padArray(rows, offset, queryRowCount) {
  const paddedArray = new Array(offset).concat(rows)
  if (queryRowCount < rows.length) {
    return paddedArray
  }
  return paddedArray.concat(new Array(queryRowCount - (offset + rows.length)))
}
